import { api, handleApiError, handleApiSuccess } from './api.js';

const ENDPOINT = '/system/maintenance-schedule';

/**
 * Fetch the active maintenance schedule configuration.
 * Accessible to all authenticated users.
 */
export const getMaintenanceSchedule = async () => {
  try {
    const response = await api.get(ENDPOINT);
    return handleApiSuccess(response);
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * Update the maintenance schedule configuration.
 * Restricted to Super Admin.
 * @param {Object} data - { is_enabled, title, message, start_time, end_time, timezone, notify_ahead_min }
 */
export const updateMaintenanceSchedule = async (data) => {
  try {
    const response = await api.put(ENDPOINT, data);
    return handleApiSuccess(response);
  } catch (error) {
    throw handleApiError(error);
  }
};

export default {
  getMaintenanceSchedule,
  updateMaintenanceSchedule,
};
